<template>
  <div class="vx-card">
      <grid-panel
          ref="distributionListGrid"
          :auto-size="true"
          :column-defs="distributionListColDefs"
          :url="url"
          @rowClicked="view"
      >
        <vs-dropdown-item v-if="componentAccess.canCreate.access">
              <span
                  class="flex items-center"
                  @click="$router.push({ name: 'company.distribution-list.create' })"
              >
                <feather-icon class="mr-2" icon="PlusIcon" svgClasses="h-4 w-4"/>
                <span>Create Distribution List</span>
              </span>
        </vs-dropdown-item>
      </grid-panel>
  </div>
</template>

<script>
import GridPanel from '@/views/components/ag-grid/GridPanel';
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

export default {
  name: 'CompanyDistributionListList',
  components: {
    GridPanel
  },
  mixins: [CanAccessMixin],
  data() {
    return {
      componentAccess: {
        canCreate: {
          route: 'company.distribution-list.create',
          access: false,
        },
      },
      url: () => this.$api.companies.relationship('distribution-lists', this.id),
      underwriterId: null,
      distributionListColDefs: [
        {
          headerName: 'Report',
          filter: 'agTextColumnFilter',
          field: 'Type',
          width: 350,
        },
        {
          headerName: 'Number of Recipients',
          filter: 'agTextColumnFilter',
          field: 'Recipients_Count',
          width: 350,
        },
      ]
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    async view({data}) {
      const route = 'company.distribution-list.view';

      if (await this.canAccessRoute(route)) {
        this.$router.push({
          name: route,
          params: {id: this.id, distributionListId: data.id}
        }).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>

</style>
